import React, { useState, useMemo, useEffect } from 'react';
import Select from 'react-select';
import getSymbolFromCurrency from "currency-symbol-map";
import { dashboardColors, theme } from '../../../themes/Theme';

const customStyles = {
    option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        background: isSelected ? dashboardColors[theme].primary : isFocused ? "#e2e8f0" : "white",
        margin: "0px",
        color: isSelected ? "white" : isFocused ? "#1a202c" : "#4a5568",
        zIndex: 10,
        overflowX: "hidden",
        wordBreak: "break-word",
        cursor: "pointer",
    }),
    menu: (provided) => ({
        ...provided,
        marginTop: "2px",
        overflow: "hidden",
        zIndex: 10,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    dropdownIndicator: (base) => ({
        ...base,
        color: dashboardColors[theme].primaryTextColor,
        padding: "5px 8px",
        zIndex: 10,
        "&:hover": {
            color: dashboardColors[theme].primaryTextColor,
        },
    }),
    control: (base, state) => ({
        ...base,
        border: state.isFocused ? `1px solid ${dashboardColors[theme].primary}` : "1px solid #cdd4db",
        boxShadow: "none",
        borderRadius: "2px",
        minHeight: "36px",
        maxHeight: "2.5em",
    }),
};

const getWhichCountrySymbolForDollar = (currency) => {
    const countrySignMap = {
        "AUD": "A",   // Australia 
        "CAD": "CA",  // Canada
        "HKD": "HK",  // Hong Kong
        "NZD": "NZ",  // New Zealand
        "SGD": "S",   // Singapore
    };
    return countrySignMap[currency] || "";
};

const ReportsCurrencyDropdown = ({
    options = [],
    value = null,
    onChange = () => {},
    placeholder = "",
    isLoading = false,
    isDisabled = false,
    isSearchable = true,
    customStyles: propStyles = {},
    className = "",
    width = "130px",
    ...otherProps
}) => {
    const [selectedOption, setSelectedOption] = useState(value);

    const handleChange = (selected) => {
        setSelectedOption(selected);
        onChange(selected);
    };

    const mergedStyles = {
        ...customStyles,
        ...propStyles
    };
    useEffect(() => {

        if (value && options?.length > 0) {
            // Find the matching option in the options array
            const matchedOption = options?.find(option =>
                option.value === value?.value ||
                option.currency_id === value?.currency_id ||
                option.value === value?.currency_id
            );

            if (matchedOption) {
                setSelectedOption(matchedOption);
            } else {
                setSelectedOption(value);
            }
        } else if (value) {
            // Even if options are empty, set the value
            setSelectedOption(value);
        } else {
            setSelectedOption(null);
        }
    }, [value, options]); 
    return (
        <div className={className} style={{ width }}>
            <Select
                value={selectedOption}
                onChange={handleChange}
                options={options}
                placeholder={isLoading ? "Loading..." : placeholder}
                styles={mergedStyles}
                isDisabled={isDisabled || isLoading}
                isSearchable={isSearchable}
                {...otherProps}
            />
        </div>
    );
};

export default ReportsCurrencyDropdown;
